'use client';

import { useChatRuntimeContext } from "../internals/useChatRuntimeContext/index.js";
export function useChatOnToolCall() {
  return useChatRuntimeContext().onToolCall;
}